module.exports = __webpack_public_path__ + "static/img/product11.aed3e9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product11.png
// module id = 4ZQr
// module chunks = 10